module.exports = __webpack_public_path__ + "img/ashley-wide.23bb40b.jpg";